import React, { useState } from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
const CustomPrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        ...style,
        left: "-50px",          // ⬅️ Move left
        zIndex: 1,
      }}
    >
      <FaArrowLeft />
    </div>
  );
};

const CustomNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        ...style,
        fontSize: "24px",       // 🔠 Change arrow size
        right: "-50px",         // ➡️ Move right
        zIndex: 1,
      }}
    >
      <FaArrowRight />
    </div>
  );
};
export default function Exclusively() {

    const data = [
        { id: 1, btn:"EXPLORE",  url:"/corporate", img: "/images/home/corporate-slider_.jpg",para:"Host impactful conferences and corporate events with seamless sophistication", title: "CORPORATE" },
        { id: 2, btn:"EXPLORE",  url:"/corporate#mebership", img: "/images/home/membership_.jpg",para:"Enjoy special discounts on corporate events and conferences with your tiered membership.", title: "MEMBERSHIP" },
        { id: 2, btn:"QUERY ",  url:"/banquet-query", img: "/images/home/hall-area_.jpg",para:"Celebrate in style with marble-finished grandeur and golden accents.", title: "MEETING ROOM" },
        { id: 3, btn:"DINING" , url:"/dining", img: "/images/dine/zaika/zaika_dine_.jpg",para:"Enter a realm of storied halls, sophisticated delights and unrivalled indulgence. Immerse yourself in the grandeur of luxury at our exquisite palaces, hotels, resorts and safaris.", title: "DINING" },
       
      ];
      const settings = {
        dots: false, // Dots indicators
        infinite: true, // Infinite scroll
        speed: 1200,
        slidesToShow: 1, // 3 cards in one row
        slidesToScroll: 1, // Scroll by 1 card
        autoplay: false, // Auto scroll
        autoplaySpeed: 5000, // 2 sec per slide
        arrows: true, // Left/Right arrows
         nextArrow: <CustomNextArrow />,
  prevArrow: <CustomPrevArrow />,
        responsive: [
          {
            breakpoint: 768, // Mobile screen
            settings: {
              slidesToShow: 1, // Show 1 card on mobile
               
            }
          }
          ,
        
        ]
      };
  return (
   <>
   



   <div className="explore-main " style={{ backgroundImage: "url('/images/home/corporate-bg_.jpg')",backgroundSize: "cover" }}>
   <div className="container ex-co ">
    <div className="container-fluid">
       <div className="row">

         <div className="col-md-12">
            <div className="explore ">
              <div className='explore-left'>
             <div className="exl-under"></div> 
              <h1>CORPORATE/</h1>
               <span> EVENTS</span>
            </div>
            <div className="explore-right">
                <p>Elegance meets purpose across corporate halls, events, and fine dining.</p>
            </div>
            </div>


            <div className="carousel-container-2 ">
     {/* <div className="col-12"> */}
     <Slider {...settings}>
        {data.map((item) => {
          return(
            <>
             <div key={item.id} className="card-2 me-1">
            <img src={item.img} loading="lazy" alt={"V Hotel The Grnad Shoba"+item.title} title={`V Hotel The Grnad Shoba-Event/Corporate`} />
            <h3>{item.title}</h3>
            <p>{item.para}</p>
             <Link to={item.url} title={`"banquet"${item.btn}`} >{item.btn} &gt;</Link>
            
            
          </div>
            </>
          )
        })}
      </Slider>
     </div>

         </div>
         
    {/* slider */}
    

        </div>  
      
    </div>
   </div>
   </div>
   </>
  )
}


